import { request } from "@/plugins/axios";
import servers from "@/servers.js";
export default {
  getList(params) {
    return request({
      url: servers.account_url + "group/user_group",
      method: "get",
      params,
    });
  },
  accountList(params) {
    return request({
      url: servers.account_url + "group/account",
      method: "get",
      params,
    });
  },
  // 获取集团账号角色个数
  getAnchorNum() {
    return request({
      url: servers.account_url + "anchor/anchor_num",
      method: "get",
    });
  },
};
